module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-loader noselect",
    class: (_vm.mini) ? 'mini' : ''
  }, [_vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    attrs: {
      "data-testid": "loader"
    }
  }, [_c('div', {
    staticClass: "demi"
  }), _vm._v(" "), _c('div', {
    staticClass: "demi"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721a5714"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/Loader/Loader.vue.html
// module id = J4IX
// module chunks = 2